import { CommonConstants } from './../utilities/commonConstants';
import { ConfigService } from '../services/config.service';
import { HttpInterceptor } from './../services/httpInterceptor.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { RouteHandlerService } from './routeHandler.service';
import { SessionHandlerService } from './sessionHandler.service';
@Injectable({
    providedIn: 'root'
})
export class ActivitiHandlerService {
    constructor(
        private _httpInterceptor: HttpInterceptor,
        private _sessionHandlerService: SessionHandlerService,
        private _router: Router,
        private _routerService: RouteHandlerService) {
    }
    public StartActiviti(data: any, isLoader?: boolean): Observable<ActivitiModel.MTResponse<any>> {
        return this._httpInterceptor.Post(
            ConfigService.getInstance().getConfigObject()
                .APIURL.startApplicationActiviti, data, isLoader);
    }
    public MarkTaskAsCompleted(
        requestData: any,
        taskName?: string,
        isLoader?: boolean,
        loadermsg?: string,
        currentTaskKey?: string,
    ): Observable<ActivitiModel.MTResponse<any>> {
        // this is typicaly for custom loader text.
        // ConfigService.getInstance().setTitle(loadermsg);
        return this._httpInterceptor.Post(ConfigService.getInstance()
            .getConfigObject().APIURL.completeActivitiTask,
            this.getCompleteTaskRequest(requestData, taskName, currentTaskKey), isLoader);
    }
    // Mark Task As Completed and navigate to next Page.
    public navigateToNextTaskKey(requestData: any, actionName: string, isLoader?: boolean) {
        this.MarkTaskAsCompleted(requestData, actionName, isLoader).subscribe(
            (mtResponse: ActivitiModel.MTResponse<null>) => {
                if (!mtResponse.errorBean) {
                    this._routerService.RouteToNextTask(mtResponse.nextTaskKey);
                }
            });
    }
    public GetTaskDetails(
        taskName?: string,
        isLoader?: boolean,
        loadermsg?: string
    ): Observable<ActivitiModel.MTResponse<any>> {
        // this is typicaly for custom loader text.
        // ConfigService.getInstance().setTitle(loadermsg);
        return this._httpInterceptor.Post(ConfigService.getInstance()
            .getConfigObject().APIURL.getActivitiTaskDetails,
            this.getTaskDetailsRequest(taskName), isLoader);
    }
    private getCompleteTaskRequest(requestData: any, taskName: string, currentTaskKey?: string): ActivitiModel.ActivitiRequest {
        return <ActivitiModel.ActivitiRequest>{
            activitiName: 'complete',
            action: taskName,
            processId: this._sessionHandlerService.GetSession(
                CommonConstants.CookieKeys.ProcessInstanceDetails),
            payload: requestData,
            value: currentTaskKey,
        };
    }
    private getTaskDetailsRequest(taskName?: string): ActivitiModel.ActivitiRequest {
        const currentRoute = this._router.url.split(CommonConstants.URL_SEPARATOR);
        return <ActivitiModel.ActivitiRequest>{
            processId: this._sessionHandlerService.GetSession(CommonConstants
                .CookieKeys.ProcessInstanceDetails),
            action: taskName,
            routesInfo: {
                mainRoute: currentRoute[1],
                subRoute: currentRoute[2] || CommonConstants.DEFAULT_EMPTY_STRING
            }
        };
    }

    public PostCallService(data, offer?) {
         /*
        JSON.parse() is used here to convert string value to boolean
        When we store values in session they get stored in string
        */
        data.payload.isSSO = JSON.parse((this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.ssoEnabled) || 'false'));
        if(offer){
            const url = ConfigService.getInstance().getConfigObject().APIURL.postCall  + '?offer='+offer;
            return this._httpInterceptor.applicationTokensPost(url, data);
        } else {
            const url = ConfigService.getInstance().getConfigObject().APIURL.postCall;
            return this._httpInterceptor.applicationTokensPost(url, data);
        }
    }
    public GetCallService() {
        const url = ConfigService.getInstance().getConfigObject().APIURL.getCall;
        return this._httpInterceptor.Get(url);

    }
    public getValidateRegistrationNo(registrationNo) {
       
        let url = ConfigService.getInstance().getConfigObject().APIURL.validateRegistrationNo;
        url = url.replace('{registrationnumber}', registrationNo);

        return this._httpInterceptor.Get(url);
    }
}
